import React from "react";
import { INNER_FEATURES_SHAPE } from "../../lib/assets";

export const FeatureSeven = () => {
  return (
    <section className="features-area-seven">
      <div className="container">
      <div className="section-title-two mb-30">
                <span className="sub-title">Top Features</span>
                <h2 className="title">
                Integrated Management Policy
                </h2>
              </div>
        <div className="row align-items-center">
          <div className="col-lg-6">
            
            <div className="features-content-seven">
              
              <p>
             {/* We specialize in delivering tailored consulting solutions for the insurance industry, 
              ensuring optimized processes, enhanced compliance, and sustainable growth. With our expertise, 
              we help you navigate challenges and unlock new opportunities in an evolving market.*/}
              We are committed to provide the best quality professional Management Consultation 
              Services to achieve Total Customer Satisfaction in an Environmental Responsible, 
              Quality and Information Security Conscious manner through continual improvement of 
              processes of Quality Management System.
              <br/>
              <br/>
              We will render our whole-hearted support, assistance, guidance and professionalism 
              to our Clients in their journey towards Perfection 

              </p>
            </div>
          </div>
         

          <div className="col-lg-6">
            <div className="features-progress-wrap">
              <div className="progress-wrap">
                <div className="progress-item">
                
                  <h6 className="title">Focus on Measurable Outcomes</h6>
                  <div
                    className="progress"
                    role="progressbar"
                    aria-label="Example with label"
                    aria-valuenow="85"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    <div
                      className="progress-bar wow slideInLeft"
                      data-wow-delay=".1s"
                      style={{
                        width: "85%",
                      }}
                    >
                      <span>85%</span>
                    </div>
                  </div>
                </div>
                <div className="progress-item">
                  <h6 className="title">Customer-Centric Perspective</h6>
                  <div
                    className="progress"
                    role="progressbar"
                    aria-label="Example with label"
                    aria-valuenow="76"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    <div
                      className="progress-bar wow slideInLeft"
                      data-wow-delay=".2s"
                      style={{
                        width: "76%",
                      }}
                    >
                      <span>76%</span>
                    </div>
                  </div>
                </div>
                <div className="progress-item">
                  <h6 className="title">Commitment to Excellence</h6>
                  <div
                    className="progress"
                    role="progressbar"
                    aria-label="Example with label"
                    aria-valuenow="90"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    <div
                      className="progress-bar wow slideInLeft"
                      data-wow-delay=".3s"
                      style={{
                        width: "90%",
                      }}
                    >
                      <span>90%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="inner-features-shape">
        <img
          src={INNER_FEATURES_SHAPE}
          alt=""
          data-aos="fade-left"
          data-aos-delay="0"
        />
      </div>
    </section>
  );
};
